import { ListViewModel } from './list.view.model';

const MaxCacheSize = 2e4;

export class CachedListViewModel<T extends any, F> extends ListViewModel<T, F> {
  public maxCacheSize: number = MaxCacheSize;

  async getByIds(ids: (number | string)[]): Promise<T[]> {
    const promises = ids.map((v: number | string) => this.getById(v));
    const items = await Promise.all(promises);
    return items.filter((v) => !!v) as T[];
  }

  async getMapByIds(ids: (number | string)[]): Promise<Record<string, T>> {
    const promises = ids.map((v: number | string) => this.getById(v));
    const items = await Promise.allSettled(promises);
    const result = items.reduce<Record<string, T>>((m: any, result: any) => {
      const v = result.value;
      v && (m[String((v as any).id)] = v);
      return m;
    }, {});
    return result;
  }

  async getById(id: number | string): Promise<T | undefined> {
    const result = this.items.find((v) => (v as any).id === id) ?? (await super.getById(id));
    this.cleanupCache();
    return result;
  }

  protected cleanupCache() {
    if (this.items.length > this.maxCacheSize) {
      this.items.splice(0, this.items.length / 2);
    }
  }
}
